/**
 * รายการไฟล์โมเดล .glb ที่มีอยู่จริง ณ ตอน build (Vite เท่านั้น)
 * วางไฟล์ที่ `client/src/assets/models/monsters/<id ใน monsters.json>.glb` แล้วเกมใช้เอง
 */

const MONSTER_FILES = import.meta.glob("./assets/models/monsters/*.glb", {
  query: "?url",
  import: "default",
  eager: true,
}) as Record<string, string>;

const CHARACTER_FILES = import.meta.glob("./assets/models/characters/*.glb", {
  query: "?url",
  import: "default",
  eager: true,
}) as Record<string, string>;

export function monsterModelUrl(id: string): string | undefined {
  for (const [path, url] of Object.entries(MONSTER_FILES)) {
    if (path.endsWith(`/${id}.glb`)) return url;
  }
  return undefined;
}

export const CLASS_BASE_MAP: Record<string, string> = {
  bastion: "warden",
  berserker: "brawler",
  elementalist: "arcanist",
  hunter: "ranger",
  assassin: "shade",
  saint: "mender",
};

export function resolveBaseClass(cls: string): string {
  return CLASS_BASE_MAP[cls] ?? cls;
}

export function characterModelUrl(cls: string, gender: string): string | undefined {
  const baseCls = resolveBaseClass(cls);
  const candidates = cls === baseCls ? [cls] : [cls, baseCls];

  for (const c of candidates) {
    const filename = `${c}_${gender}.glb`;
    for (const [path, url] of Object.entries(CHARACTER_FILES)) {
      if (path.endsWith(`/${filename}`)) return url;
    }
  }
  return undefined;
}

const CHARACTER_SPRITES = import.meta.glob("./assets/sprites/characters/*.png", {
  query: "?url",
  import: "default",
  eager: true,
}) as Record<string, string>;

export interface CharacterSpriteUrls {
  front?: string;
  side?: string;
  back?: string;
}

export function characterSpriteUrls(cls: string, gender: string): CharacterSpriteUrls | undefined {
  const baseCls = resolveBaseClass(cls);
  const candidates = cls === baseCls ? [cls] : [cls, baseCls];

  for (const c of candidates) {
    const frontName = `${c}_${gender}_front.png`;
    const sideName = `${c}_${gender}_side.png`;
    const backName = `${c}_${gender}_back.png`;

    let front: string | undefined;
    let side: string | undefined;
    let back: string | undefined;

    for (const [path, url] of Object.entries(CHARACTER_SPRITES)) {
      if (path.endsWith(`/${frontName}`)) front = url;
      else if (path.endsWith(`/${sideName}`)) side = url;
      else if (path.endsWith(`/${backName}`)) back = url;
    }

    if (front || side || back) {
      return { front, side, back };
    }
  }

  return undefined;
}



